import type { TNavbarMenuElement } from '@shared/dream-components';
import { NavbarMenuV2 as NavbarMenuElement } from '@shared/dream-components';
import { type ReactNode, useState } from 'react';
import { NavbarBurgerContext } from './NavbarMenuBurger.context';

interface Props {
  node: TNavbarMenuElement;
  children: ReactNode | ReactNode[];
  screen: 'desktop' | 'mobile';
}

const NavbarMenu = ({ node, children, screen }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <NavbarBurgerContext.Provider value={{ isOpen, setIsOpen }}>
      <NavbarMenuElement element={node} screen={screen}>
        {children}
      </NavbarMenuElement>
    </NavbarBurgerContext.Provider>
  );
};

export default NavbarMenu;
